import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { nonLoggedInExchangeRate } from "../../services/remittance";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import InvestorStrip from "./components/InvestorStrip";
import PressSection from "./components/PressSection";
import ProductShowcase from "./components/ProductShowcase";
import RateComparison from "./components/RateComparison";
import {
  DEFAULT_USD_AMOUNT,
  getRateViewModel,
  getUsdAmountForRecipient,
} from "./components/rateUtils";
import styles from "./styles/GetAppLanding.module.scss";

const GetAppLanding = () => {
  const remoteConfig = useSelector((state) => state.app.remoteConfig);
  const [exchangeData, setExchangeData] = useState({});
  const [usdAmount, setUsdAmount] = useState(DEFAULT_USD_AMOUNT);

  useEffect(() => {
    console.log("GetAppLanding remoteConfig", remoteConfig);
  }, [remoteConfig]);

  useEffect(() => {
    const controller = new AbortController();
    nonLoggedInExchangeRate({ signal: controller.signal })
      .then((data) => {
        if (data) {
          setExchangeData(data);
        }
      })
      .catch((error) => {
        if (error?.name !== "CanceledError") {
          console.log(error);
        }
      });

    return () => controller.abort();
  }, []);

  const rateModel = useMemo(
    () => getRateViewModel(exchangeData, usdAmount),
    [exchangeData, usdAmount],
  );

  const handleRecipientAmountChange = (recipientAmount) => {
    setUsdAmount(getUsdAmountForRecipient(exchangeData, recipientAmount));
  };

  return (
    <main className={styles.page}>
      <Header />
      <Hero
        rateModel={rateModel}
        onUsdAmountChange={setUsdAmount}
        onRecipientAmountChange={handleRecipientAmountChange}
      />
      <InvestorStrip />
      <RateComparison rateModel={rateModel} />
      <ProductShowcase />
      <PressSection />
      <FAQSection />
      <Footer />
    </main>
  );
};

export default GetAppLanding;
